import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import AiFields from "../components/AIFields";

function CoxProportionalHazards({
  action,
  variables,
  setOpenVariable,
  automId,
}) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <div className="form-element">
        <Button onClick={() => setOpen(true)} variant="outlined">
          Configure
        </Button>
      </div>
      {open && (
        <AiFields
          data={[
            "model_id",
            "training_frame",
            "start_column",
            "stop_column",
            "response_column",
            "ties",
            "init",
            "ire_min",
            "max_iterations",
          ]}
          setOpen={setOpen}
          action={action}
          variables={variables}
          setOpenVariable={setOpenVariable}
          automId={automId}
        />
      )}
    </div>
  );
}

export default CoxProportionalHazards;
